<template>
	<b-container class="text-left tb-margin">
	  <b-row class="mb-3" align-h="center">
	    <b-col class="top-title" sm="12" md="6">
	    	{{ $t('login') }}
	    </b-col>
	  </b-row>

	  <b-row class="mb-3" align-h="center">
	    <b-col sm="12" md="6">
	    	<span style="font-weight:300">{{ $t('username') }}</span><br>
			<b-form-input size="sm" type="text" v-model="user" :placeholder="$t('username-enter')"></b-form-input>
	    </b-col>
	  </b-row>
	  <b-row class="mb-4" align-h="center">
	    <b-col sm="12" md="6">
	    	<span style="font-weight:300">{{ $t('password') }}</span><br>
			<b-form-input size="sm" type="password" v-model="password" @keyup.enter="doLogin()" :placeholder="$t('password-enter')"></b-form-input>
	    </b-col>
	  </b-row>
	  <b-row v-if="loginError" class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div class="gera-btn" style="background-color:darkred !important;font-size:0.9em !important;cursor:default;">{{loginErrorText}}</div>
	    </b-col>
	  </b-row>
	  <b-row class="mb-3 text-center" align-h="center">
	    <b-col sm="12" md="6">
		  <div v-if="!logging" class="gera-btn pt-3 pb-3" @click="doLogin()">{{ $t('login') }}</div>
 		  <div v-else class="text-center">
			<b-spinner variant="primary"></b-spinner>
		  </div>
	    </b-col>
	  </b-row>
	  <b-row class="mb-3" sm="12" md="6" align-h="center">
	    <b-col sm="6" lg="3" class="cursorp">
			<b-form-checkbox
				id="checkbox-1"
				v-model="stayLogged"
				name="checkbox-1"
				value="true"
				unchecked-value="false"
	    	>
				{{ $t('remember-me') }}
			</b-form-checkbox> 
	    </b-col>
	    <b-col sm="6" lg="3" @click="showPassForget()" style="color:#307bad;text-decoration: underline;cursor: pointer; text-align:right;">
				{{ $t('pass-forget') }}
	    </b-col>
	  </b-row>
	</b-container>
</template>
<script>
export default {
  name: "login",
  props: {
  },
  data () {
    return {
    	showForm: true,
    	logging: false,
	    user: '',
	    password: '',
		stayLogged: false
    }
  },
  
  mounted() {
	this.$nextTick(()=>{
		if (!this.loggedIn){
			this.user = localStorage.getItem('storedUser');
			this.password = localStorage.getItem('storedPass');
			if (this.user != null && this.password != null) { 
				this.doLogin();
				return false;
			}
		}
	})
  },
  methods: {
  	showPassForget() {
	  this.$emit('showPasswordForget');
 	},
  	doLogin () {
	  this.$store.dispatch('resetBadLogin');
	  if (!this.user || !this.password) return false;
      this.errors = [];
      this.logging = true;
      this.$store.dispatch('login', { user: this.user, password: this.password})
        .then((result) => {
	      this.logging = false;
	      if (this.$store.getters.isLoggedIn) {
	      	this.$emit('loggedIn');
	      }
	      
	      if (this.$store.getters.isLoggedIn && this.stayLogged) {
	      	localStorage.setItem('storedUser', this.user);
	      	localStorage.setItem('storedPass', this.password);
	      	this.user = '';
	      	this.password = '';
	      }
        })
        .catch(error => {
	      this.logging = false;
          this.errors.push(error);
		  this.error = true;
		  /*
		  setTimeout(()=>{
			this.$store.dispatch('resetBadLogin');
			this.error = true;
		  }, 5000)
		  */
        })
  	},
  },
  computed: {
    loggedIn () {
      return this.$store.getters.isLoggedIn
    },
    loginError () {
      return this.$store.getters.hasLoginErrored
    },
    loginErrorText () {
      return this.$store.getters.getLoginErrorText
    }
  }
};
</script>
<i18n>
	{
		"sl": {
			"login": "Prijava",
			"username": "Uporabniško ime",
			"password": "Geslo",
			"username-enter": "Vpišite uporabniško ime",
			"password-enter": "Vpišite geslo",
			"pass-forget": "Pozabil sem geslo",
			"remember-me": "zapomni si prijavo"
		},
		"de": {
			"login": "Anmeldung",
			"username": "Benutzername",
			"password": "Passwort",
			"username-enter": "Benutzername eingeben",
			"password-enter": "Passwort eingeben",
			"pass-forget": "Passwort vergessen",
			"remember-me": "Angemeldet bleiben"
		},
		"en": {
			"login": "Login",
			"username": "Username",
			"password": "Password",
			"username-enter": "Enter username",
			"password-enter": "Enter password",
			"pass-forget": "Forgot password",
			"remember-me": "Remember me"
		}
	}
</i18n>
